import React, { Component } from 'react'
import { connect } from 'kea'
import ReactDOM from 'react-dom'

import SharedMap from '~/scenes/shared/map'
import Marker from '~/scenes/shared/map/marker'

import preloadImages from 'lib/utils/preload-images'
import { coordsEqual } from './utils'

import railsContext from 'lib/selectors/rails-context'
import sceneLogic from '~/scenes/search/logic'
import mapLogic from './logic'

@connect({
  actions: [
    mapLogic,
    ['performMapSearch', 'updateMapPosition', 'updateMapCenterZoom', 'closeMap'],
    sceneLogic,
    ['hoverLocation', 'focusResult', 'geolocate']
  ],
  props: [
    mapLogic,
    ['mapPosition', 'temporaryMapPosition', 'temporaryResults', 'filterMapPosition'],
    sceneLogic,
    [
      'results',
      'filter',
      'hoverResultId',
      'hoverLocationId',
      'isGeolocating',
      'isFullScreenMap',
      'isExtraSmallScreen',
      'isSmallScreen'
    ],
    railsContext,
    ['dpr']
  ]
})
export default class Map extends Component {
  constructor (props) {
    super(props)
    this._blockBounds = false
  }

  componentDidMount () {
    this.preloadImages()
  }

  preloadImages () {
    const { dpr } = this.props
    const finalDpr = typeof window !== 'undefined' ? window.devicePixelRatio || dpr : dpr
    const dprExtension = finalDpr >= 2 ? '@2x' : ''

    const images = [
      `/images/map/pin-green-large${dprExtension}.png`,
      `/images/map/pin-green-large-hover${dprExtension}.png`
    ]

    preloadImages(images)
  }

  setRef = ref => {
    this._mapRef = ref
  }

  setZoom = zoom => {
    const { updateMapCenterZoom } = this.actions
    const {
      mapPosition: { center }
    } = this.props
    updateMapCenterZoom(center, zoom)
  }

  handleMouseOver = location => {
    const { hoverLocation } = this.actions
    hoverLocation(location)
  }

  handleMouseOut = () => {
    const { hoverLocation } = this.actions
    hoverLocation(null)
  }

  renderObjects () {
    const { results, temporaryResults, hoverResultId, hoverLocationId, dpr } = this.props
    const { focusResult } = this.actions

    const resultsForLocation = {}
    const locations = {}

    ;(temporaryResults || results).results.forEach(result => {
      result.locations.forEach(location => {
        if (!resultsForLocation[location.id]) {
          resultsForLocation[location.id] = []
          locations[location.id] = location
        }
        resultsForLocation[location.id].push(result)
      })
    })

    const mapObjects = []

    Object.keys(resultsForLocation).forEach(locationIdString => {
      const locationId = parseInt(locationIdString)
      const location = locations[locationId]
      const resultsForThisLocation = resultsForLocation[locationId]
      const hover =
        hoverLocationId === locationId || (hoverResultId && resultsForThisLocation.some(r => r.id === hoverResultId))

      mapObjects.push(
        <Marker
          key={`location-${locationId}`}
          resultId={resultsForThisLocation[0].id}
          anchor={[location.latitude, location.longitude]}
          offset={[0, 0]}
          lat={location.latitude}
          lng={location.longitude}
          location={location}
          onMouseOver={this.handleMouseOver}
          onMouseOut={this.handleMouseOut}
          onClick={focusResult}
          hover={!!hover}
          dpr={dpr}
        />
      )
    })

    return mapObjects
  }

  blockBoundsChanges = () => {
    this._blockBounds = true
  }

  unblockBoundsChanges = () => {
    this._blockBounds = false
  }

  updateMapPosition = object => {
    const { isSmallScreen, filter } = this.props
    const { updateMapPosition } = this.actions

    const isFullscreenMap = filter && filter.filters === 'map'

    if (this._blockBounds) {
      return
    }

    const mapDiv = ReactDOM.findDOMNode(this._mapRef)
    if (mapDiv) {
      const width = mapDiv.clientWidth
      const height = mapDiv.clientHeight

      if (!isSmallScreen || isFullscreenMap) {
        updateMapPosition({ ...object, width, height })
      }
    }
  }

  render () {
    const {
      isGeolocating,
      dpr,
      mapPosition,
      filterMapPosition,
      temporaryMapPosition,
      isFullScreenMap,
      isExtraSmallScreen
    } = this.props
    const { geolocate, performMapSearch, closeMap } = this.actions
    const { center, zoom } = mapPosition

    const withSearchHereButton =
      isFullScreenMap &&
      temporaryMapPosition &&
      (!coordsEqual(filterMapPosition.center, temporaryMapPosition.center) ||
        filterMapPosition.zoom !== temporaryMapPosition.zoom)

    if (!isFullScreenMap && isExtraSmallScreen) return null

    return (
      <SharedMap
        id='search-page-main-pigeon-map'
        withSearchHereButton={isExtraSmallScreen || withSearchHereButton}
        withCloseButton={isFullScreenMap && !isExtraSmallScreen}
        onCloseClicked={closeMap}
        onSearchHereClicked={performMapSearch}
        dpr={dpr}
        zoom={zoom}
        center={center}
        isGeolocating={isGeolocating}
        geolocate={geolocate}
        onAnimationStart={this.blockBoundsChanges}
        onAnimationStop={this.unblockBoundsChanges}
        onBoundsChanged={this.updateMapPosition}
        setZoom={this.setZoom}
        zoomClass='bottom-right'
        setRef={this.setRef}
        objects={this.renderObjects()}
        childPropsUpdateTrigger={['key', 'hover']}
      />
    )
  }
}
